import React from 'react'
import { Maximize2 } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { tamanhosApi } from '../../api/tabelasBasicas'

const TamanhosPage: React.FC = () => {
  return (
    <GenericTabelaPage
      titulo="Tamanhos"
      breadcrumb="Tabelas › Básicas"
      icon={<Maximize2 size={17} />}
      cdMaxLen={2}
      nmMaxLen={30}
      api={tamanhosApi}
    />
  )
}

export default TamanhosPage
